module.exports = __webpack_public_path__ + "img/Individual_Isotype-Light.5a8a199e.svg";